import ModelProxy from "../../model-proxy"
import {EntityType} from "../../../gd/const/item"
import ModelEntity from "../../model-entity"
import DatetimeUtils from "../../../gd/utils/datetime-utils"
import {ChatType} from "./const"
import ActionItemsDeprecated from "../../todo/deprecated/action-items-deprecated"

const debug = false
// const debug = "Chat"

export default class Chat extends ModelEntity {

    public name                 : string
    public projectId?           : ID
    public momentLastUpdated    : Moment
    public systemType           : ChatType
    public companyId            : ID
    public user1Id?             : ID
    public user2Id?             : ID
    public users!               : any[]
    public newMessages          : number = 0
    public talkToUserId?        : ID
    private _lastMessage?       : string

    public momentCreated        : Moment
    public createdByUserId      : ID

    public todoTasks            : any   // Discussions
    public todo                 : any   // Discussions

    constructor(data:any, useProxy = true) {
        super(data['id'], EntityType.CHAT)

        this.name               = data['name']
        this.companyId          = data['companyId']
        this.projectId          = data['projectId']
        this.systemType         = data['systemType']
        this.createdByUserId    = data['createdByUserId']
        this.user1Id            = data['user1Id']
        this.user2Id            = data['user2Id']
        this._parseUsers(data)

        this.newMessages        = data['newMessages']
        this._lastMessage       = data['lastMessage']
        this.todoTasks          = data['todoTasks']

        const todo      = _.get(data, 'todo', null)
        this.todo       = new ActionItemsDeprecated(this, this._getAccess(), todo)

        this.momentLastUpdated  = data['momentLastUpdated'] ? DatetimeUtils.datetimeToMoment(data['momentLastUpdated']) : moment()
        this.momentCreated      = data['momentCreated'] ? DatetimeUtils.datetimeToMoment(data['momentCreated']) : moment()

        // Init talkToUser for 1-2-1 chats
        if (this.systemType === ChatType.USER) {
            this.talkToUserId = this.user1Id === gd.user.id ? this.user2Id : this.user1Id
        }

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    _parseUsers = (data: any) => {
        const createdByUserId   = _.get(data, 'createdByUserId', null)
        const users             = _.get(data, 'users', [])

        this.users = []

        _.map(users, userId=>{
            this.users!.push({
                userId  : userId,
                role    : userId === createdByUserId ? gd.const.meeting.role.ORGANIZER : gd.const.meeting.role.PARTICIPANT
            })
        })
    }

    _getAccess = () => {
        return {
            add : true,
            edit: this.role === gd.const.meeting.role.ORGANIZER
        }
    }

    get role() {
        let res
        const chatUser = _.find(this.users, user=>user.userId === gd.session.me.id)

        if (chatUser) {
            res = chatUser.role
        } else {
            // ok dlya project discussion u nas view mode est' - vse project users krome limited mogut smotret'
            // esli mi suda popali znachit dostup est'
            res = gd.const.meeting.role.PARTICIPANT
        }
        return res
    }

    get title() {
        let res

        switch (this.systemType) {
            case gd.const.chat.systemType.USER:
                const userId = _.without([this.user1Id, this.user2Id], gd.session.me.id)[0]
                res = userId ? gd.session.users.get(userId)!.name : 'Direct chat'
                break

            default:
                res = this.name
                break
        }

        return res
    }

    get url():string {
        return "chat/" +this.id
    }

    get lastMessage():string {
        return this._lastMessage || ""
    }

    set lastMessage(message:string) {
        this._lastMessage = message?.substring(0,100)
    }

    get project() {
        return gd.session.projects.get(this.projectId)
    }

    get userIds() {
        return _.map(this.users, u=>u.userId)
    }

    setName = (value: any) =>    {
        this.name = value
        this.save('name')
    }

    setUsers = async (users: any[]) =>   {
        const newUsers      = _.differenceBy(users, this.users!, u=>u.userId)
        const removedUsers  = _.differenceBy(this.users, users, u=>u.userId)

        if (newUsers.length > 0)        await gd.api.Chat.newUsers(this.id, _.map(newUsers, user=>user.userId)).promise()
        if (removedUsers.length > 0)    await gd.api.Chat.removeUsers(this.id, _.map(removedUsers, user=>user.userId)).promise()

        this.users = users
    }

    applyDelta = (data: any) => {

        let dataChanged = true

        _.mapKeys(data, (value,key)=>{
            switch (key) {
                case 'name' :
                    this.name = _.get(data, 'name', [])
                    break

                case 'users':
                    this.users = []
                    const {createdByUserId} = this.toJSON()
                    _.map(data.users, userId=>{
                        this.users.push({userId:userId, role: userId === createdByUserId ? gd.const.meeting.role.ORGANIZER : gd.const.meeting.role.PARTICIPANT})
                    })
                    break

                case 'todo' :
                    this.todo = new ActionItemsDeprecated(this, this._getAccess(), data.todo)
                    break
            }
        })

        if (_.intersection(_.keys(data), ['name','users']).length > 0) gd.bus.triggerEvent("chat-room:update-header")
        if (_.intersection(_.keys(data), ['todo']).length > 0) {
            gd.bus.triggerEvent("chat-room:update-header") // for action items counters update
            gd.bus.triggerEvent("chat-room:update-action-items")
        }

        return dataChanged
    }

    toJSON = () => {
        const res: any = {
            id              : this.id,
            name            : this.name,
            projectId       : this.projectId,
            systemType      : this.systemType,

            user1Id         : this.user1Id,
            user2Id         : this.user2Id,
            createdByUserId : _(this.users).filter(user=>user.role === gd.const.meeting.role.ORGANIZER).map(user=>user.userId).value()[0],
            users           : _(this.users).filter(user=>user.role === gd.const.meeting.role.PARTICIPANT).map(user=>user.userId).value(),

            todoTasks       : this.todoTasks,
        }

        if (!_.isNil(this.todo)) {
            res.todo = this.todo.toJSON()
        }

        return res
    }

    save = (updateParameters: any) => {
        const res = this.toJSON()

        switch (updateParameters) {
            case 'name':    gd.api.Chat.chatRename(this.id, res.name); break
            case 'todo':    gd.api.Chat.updateTodo(this.id, res.todo); break

            default:
                const updateData = updateParameters ? _.pick(res, updateParameters) : res
                debug && console.log(debug, "save", updateParameters, updateData)

                // gd.api.Chat.discussionUpdate(res.id, updateData)
                break
        }
    }
}
